import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Resets window scroll to the top on every pathname change.
 * Preserves scroll when the URL changes only via hash (in-page anchors).
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash]);

  return null;
};
